import React from "react";
import { Route, Link } from "react-router-dom";
import { PageSettings } from "./../../config/page-settings.js";
import Config from "../../Config.js";

class SidebarNavList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: -1,
      clicked: -1,
      totalCount: 0,
      emailtotalCount: 0,
      userrole: localStorage.getItem("loginRoleName"),
    };
    this.UnreadTotalCount = this.UnreadTotalCount.bind(this);
  }
  // componentDidMount() {
  //   // // let Rolename = localStorage.getItem("loginRoleName");
  //   // // console.log("Rolename===>", Rolename);
  //   // this.setState({ userrole: Rolename });
  //   this.UnreadTotalCount();
  // }
  componentDidMount() {
    this.timerID = setInterval(() => this.UnreadTotalCount(), 20000);
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  UnreadTotalCount() {
    let loginRoleName = localStorage.getItem("loginRoleName");
    if (loginRoleName !== "SuperAdmin") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      if (
        Auth0token !== null &&
        Auth0token !== "" &&
        Auth0token !== undefined &&
        loginid !== null &&
        loginid !== "" &&
        loginid !== undefined
      )
        try {
          fetch(Config.apiUrl + "ChatMessage/WebUnReadMessageCount", {
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
            method: "GET",
          }).then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
            .then((responseJson) => {
              // { path: "/inbox", icon: "fas fa-inbox", title: "STT APP Chat", label: {} },
              this.setState({ emailtotalCount: responseJson?.emailChatUnReadMessageCount });

            })
            .catch((error) => {
              console.log(error);
              this.setState({ totalCount: 0 });
              this.setState({ emailtotalCount: 0 });
            });
        } catch (error) {
          console.log("SidebarTotalUnreadMessegeCountError==>", error);
        }
    } else {
      clearInterval(this.timerID);
    }
  }
  handleExpand(e, i, match) {
    e.preventDefault();

    this.setState((state) => ({
      active: this.state.active === i ? -1 : i,
      clicked: 1,
    }));
  }

  render() {
    var icon = this.props.data.icon && <i className={this.props.data.icon}></i>;
    console.log("Rp==>", icon)
    var img = this.props.data.img && (
      <div className="icon-img">
        <img src={this.props.data.img} alt="" />
      </div>
    );
    var caret = this.props.data.children && !this.props.data.badge && (
      <b className="caret"></b>
    );
    var label = this.props.data.label && (
      <span className="label label-theme m-l-5">{this.state.totalCount}</span>
    );
    var emaillabel = this.props.data.emaillabel && (
      <span className="label label-theme m-l-5">{this.state.emailtotalCount}</span>
    );

    var badge = this.props.data.badge && (
      <span className="badge pull-right">{this.props.data.badge}</span>
    );
    var title = this.props.data.title && (
      <span>
        {this.props.data.title} {label} {emaillabel}
      </span>
    );

    var highlight = this.props.data.highlight && (
      <i className="fa fa-paper-plane text-theme"></i>
    );
    return (
      <PageSettings.Consumer>
        {({
          handleSidebarOnMouseOver,
          handleSidebarOnMouseOut,
          pageSidebarMinified,
          toggleMobileSidebar
        }) => (
          <Route
            path={this.props.data.path}
            exact={this.props.data.exact}
            children={({ match }) => (
              <li
                className={
                  (match ? "active " : "") +
                  (this.props.active ||
                    (this.props.clicked === -1 && match) ||
                    this.props.data.search
                    ? "expand "
                    : "closed ") +
                  (this.props.data.children ? "has-sub " : "")
                }
              >
                {this.props.data.children ? (
                  <Link
                    to={this.props.data.path}
                    onMouseOver={(e) =>
                      handleSidebarOnMouseOver(e, this.props.data)
                    }
                    onMouseOut={(e) =>
                      handleSidebarOnMouseOut(e, this.props.data)
                    }
                    onClick={this.props.expand}
                  >
                    {caret} {badge} {img} {icon} {title} {highlight}
                  </Link>
                ) : (
                  <Link to={this.props.data.path}
                    onClick={toggleMobileSidebar}
                  >
                    {caret} {img} {icon} {badge} {title} {highlight}
                  </Link>
                )}
                {this.props.data.children && (
                  <ul
                    className={
                      "sub-menu " +
                      ((this.props.active ||
                        (this.props.clicked === -1 && match) ||
                        this.props.data.search) &&
                        !pageSidebarMinified
                        ? "d-block "
                        : "d-none")
                    }
                  >
                    {this.props.data.children &&
                      this.props.data.children.map((submenu, i) => (
                        <SidebarNavList
                          data={submenu}
                          key={"submenu_" + i}
                          expand={(e) => this.handleExpand(e, i, match)}
                          active={i === this.state.active}
                          clicked={this.state.clicked}
                        />
                      ))}
                  </ul>
                )}
              </li>
            )}
          />
        )}
      </PageSettings.Consumer>
    );
  }
}

export default SidebarNavList;
